import React from "react";

const Agreement = ({ agreed, setAgreed }) => {
  return (
    <div className="p-2 bg-white rounded-lg shadow-sm">
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Infuber Affiliate Agreement
        </h3>
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
          <p className="text-gray-700 leading-relaxed mb-4">
            Please review the affiliate agreement carefully. By continuing, you confirm that you understand and accept all terms outlined below.
          </p>
          <div className="h-48 overflow-y-auto bg-white border border-gray-200 rounded p-4 text-sm text-gray-600 space-y-3">
            <p><strong>1. Eligibility:</strong> You must be at least 18 years old to participate in the Infuber Affiliate Program.</p>

            <p><strong>2. Affiliate Responsibilities:</strong> You agree to promote Infuber products/services ethically and not engage in misleading, spammy, or illegal promotion tactics.</p>

            <p><strong>3. Commission Structure:</strong> You will earn a commission for each valid purchase made using your unique affiliate link. Commissions will be tracked and paid out monthly after a review period.</p>

            <p><strong>4. Prohibited Content:</strong> Your promotional content must not include hate speech, adult content, piracy, or anything that could damage Infuber's reputation.</p>

            <p><strong>5. Termination:</strong> Infuber reserves the right to suspend or terminate your affiliate account at any time for violation of terms or suspicious activity.</p>

            <p><strong>6. Payout Info:</strong> Ensure your bank or UPI details are correct. Infuber is not responsible for failed payments due to incorrect info.</p>

            <p><strong>7. Confidentiality:</strong> All non-public data provided via the Infuber Dashboard must remain confidential.</p>

            <p><strong>8. Changes:</strong> Infuber may update these terms at any time. Continued participation after changes constitutes acceptance.</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <label className="flex items-center space-x-3 cursor-pointer">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            className="form-checkbox h-5 w-5 text-orange-500 rounded border-gray-300 focus:ring-orange-400"
          />
          <span className="text-sm font-medium text-gray-700">
            I agree to the Infuber Affiliate Terms and Conditions
          </span>
        </label>
      </div>
    </div>
  );
};

export default Agreement;




// import React from "react";

// const Agreement = ({ agreed, setAgreed }) => {
//   return (
//     <div className="p-6 bg-white rounded-lg shadow-sm">
//       <div className="mb-6">
//         <h3 className="text-xl font-semibold text-gray-800 mb-4">Terms & Conditions</h3>
//         <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
//           <p className="text-gray-700 leading-relaxed mb-4">
//             Please read and agree to the affiliate agreement before proceeding. By agreeing, you acknowledge and accept our terms and conditions.
//           </p>
//           <div className="h-40 overflow-y-auto bg-white border border-gray-200 rounded p-4 text-sm text-gray-600">
//             {/* Terms content */}
//             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
//             Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
//           </div>
//         </div>
//       </div>

//       <div className="flex items-center justify-between">
//         <label className="flex items-center space-x-3 cursor-pointer">
//           <input
//             type="checkbox"
//             checked={agreed}
//             onChange={(e) => setAgreed(e.target.checked)}
//             className="form-checkbox h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
//           />
//           <span className="text-sm font-medium text-gray-700">I agree to the terms and conditions</span>
//         </label>
//       </div>
//     </div>
//   );
// };

// export default Agreement;
